import { ICategoriesData } from '@/interfaces/categories';

export const categoriesData: ICategoriesData[] = [
  {
    slug: 'hoat-hinh',
    title: 'Anime',
  },
  {
    slug: 'hanh-dong',
    title: 'Hành Động',
  },
  {
    slug: 'phieu-luu',
    title: 'Phiêu lưu',
  },
  {
    slug: 'khoa-hoc-vien-tuong',
    title: 'Khoa Học Viễn Tưởng',
  },
  {
    slug: 'phim-hai',
    title: 'Hài',
  },
  {
    slug: 'phim-18',
    title: 'Phim 18+',
  },
  {
    slug: 'chinh-kich',
    title: 'Chính Kịch',
  },
  {
    slug: 'tinh-cam',
    title: 'Tình Cảm',
  },
  {
    slug: 'hinh-su',
    title: 'Hình Sự',
  },
  {
    slug: 'kinh-di',
    title: 'Lịch Sử',
  },
  {
    slug: 'bi-an',
    title: 'Bí Ẩn',
  },
  {
    slug: 'chien-tranh',
    title: 'Chiến Tranh',
  },
  {
    slug: 'co-trang',
    title: 'Cổ Trang',
  },
  {
    slug: 'mien-tay',
    title: 'Miền Tây',
  },
  {
    slug: 'gay-can',
    title: 'Gay Cấn',
  },
  {
    slug: 'lang-man',
    title: 'Lãng Mạn',
  },
  {
    slug: 'gia-dinh',
    title: 'Gia Đình',
  },
  {
    slug: 'gia-tuong',
    title: 'Giả Tưởng',
  },
  {
    slug: 'tai-lieu',
    title: 'Tài liệu',
  },
];

export const styleMovie: ICategoriesData[] = [
  {
    title: 'TV shows',
    slug: 'tv-shows',
  },
  {
    title: 'Phim lẻ',
    slug: 'phim-le',
  },
  {
    title: 'Phim bộ',
    slug: 'phim-bo',
  },
  {
    title: 'Phim đang chiếu',
    slug: 'phim-dang-chieu',
  },
];

export const dataCountry: ICategoriesData[] = [
  {
    slug: 'au-my',
    title: 'Âu Mỹ',
  },
  {
    slug: 'anh',
    title: 'Anh',
  },
  {
    slug: 'trung-quoc',
    title: 'Trung Quốc',
  },
  {
    slug: 'indonesia',
    title: 'Indonesia',
  },
  {
    slug: 'viet-nam',
    title: 'Việt Nam',
  },
  {
    slug: 'phap',
    title: 'Pháp',
  },
  {
    slug: 'hong-kong',
    title: 'Hồng Kông',
  },
  {
    slug: 'han-quoc',
    title: 'Hàn Quốc',
  },
  {
    slug: 'nhat-ban',
    title: 'Nhật Bản',
  },
  {
    slug: 'thai-lan',
    title: 'Thái Lan',
  },
  {
    slug: 'dai-loan',
    title: 'Đài Loan',
  },
  {
    slug: 'nga',
    title: 'Nga',
  },
  {
    slug: 'ha-lan',
    title: 'Hà Lan',
  },
  {
    slug: 'philippines',
    title: 'Philippines',
  },
  {
    slug: 'an-do',
    title: 'Ấn Độ',
  },
  {
    slug: 'quoc-gia-khac',
    title: 'Quốc gia khác',
  },
];

export const years: string[] = [
  '2004',
  '2005',
  '2006',
  '2007',
  '2008',
  '2009',
  '2010',
  '2011',
  '2012',
  '2013',
  '2014',
  '2015',
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
];
